import { CheckCircleTwoTone, PrinterOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ModalWithMessageAndAction = (props) => {

  let navigate = useNavigate();

  const changeLocation = (placeToGo) => {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  // useEffect(()=>{
  //   console.log("Props",props)
  // },[props]);

  return (
    
    <div>
    
      <>{console.log('props',props)}</>
    
      <Modal
        title={props.responseModal.responseModalTitle}
        centered
        visible={props.responseModal.isOpenModal}
        open={props.responseModal.isOpenModal}
        closable={false}
        // onCancel={props.handleCancel}
        footer={[
         
            props.responseModal.printReuired ? <>
          {/* <Button key="back" style={{ margin: 1 }}>
            <PrinterOutlined /> Print
          </Button> */}
          <a href={props?.responseModal?.printUrl} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="default"><PrinterOutlined /> Print</Button>
          </a>
            </> : <></>
         
          ,

          <Link to={props.responseModal.listLink} style={{ margin: 1 }}>
            <Button htmlType="button" type="primary">
              {" "}
              <EyeOutlined /> View List
            </Button>
          </Link>,

          <Link
            to={props.responseModal.addmoreLink}
            onClick={() => changeLocation(props.responseModal.addmoreLink)}
            style={{ margin: 1 }}
          >
            <Button htmlType="button" type="danger">
              {" "}
              <EyeOutlined /> Add More
            </Button>
          </Link>,

         
          
        ]}
        style={{ width: "100px" }}
        className="responseModal"
      >
        <div style={{ textAlign: "center" }}>
          <CheckCircleTwoTone
            twoToneColor="#52c41a"
            style={{ fontSize: "2.5rem" }}
          />
          <h3>{props.responseModal.responseModalMessage}</h3>
        </div>
      </Modal>

    </div>
  );
};

export default ModalWithMessageAndAction;
